// extracted by mini-css-extract-plugin
export default {"container":"OverlayedImage_container__9j-Mo"};